//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import ITokenProvider from "../../node_modules/arc4u.framework.js/token/ITokenProvider";
import TokenProviderFactory from "../../node_modules/arc4u.framework.js/token/TokenProviderFactory";
import { getChoosenLanguage } from '@/lib/locale';
import { registerForm } from '@/fixtures/register';
export class OAuthBase {
    protected transformOptions(options: RequestInit): Promise<RequestInit> {
        return new Promise<RequestInit>((resolve, reject) => {
            const choosenLanguage = getChoosenLanguage();
            if(choosenLanguage) options.headers = { ...options.headers, 'Accept-Language' : choosenLanguage }
            if(registerForm.recaptchaToken && registerForm.recaptchaToken !== '') options.headers = { ...options.headers, 'g-recaptcha-token': registerForm.recaptchaToken }
            resolve(options);
        });
    }
}

export class AgreementAckClient extends OAuthBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets information about the agreements acknowledged by a candidate.
     * @param candidateId The unique identifier of the candidate.
     * @return A T:AgreementAckResult describing the acknowledged agreements.
     */
    getCandidateAgreementAcks(candidateId: string): Promise<AgreementAckResult> {
        let url_ = this.baseUrl + "/Legal/facade/candidate/{candidateId}/agreement";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCandidateAgreementAcks(_response);
        });
    }

    protected processGetCandidateAgreementAcks(response: Response): Promise<AgreementAckResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementAckResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgreementAckResult>(null as any);
    }

    /**
     * Submits the agreements acknowledged by a candidate.
     * @param candidateId The unique identifier of the candidate.
     * @param agreementCodes The string array representing the agreements that have been acknowledged by the candidate.  If the array of string is empty, the compliance flag will be turned off and the candidate will only be allowed to create fast-track CMUs.
     * @return A T:string collection describing the agreements by specifying their code.
     */
    submitCandidateAgreementAcks(candidateId: string, agreementCodes: string[]): Promise<void> {
        let url_ = this.baseUrl + "/Legal/facade/candidate/{candidateId}/agreement";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agreementCodes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitCandidateAgreementAcks(_response);
        });
    }

    protected processSubmitCandidateAgreementAcks(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AgreementClient extends OAuthBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets information about the acknowledgeable agreements for a candidate.
     * @return A T:AgreementAckResult describing the acknowledgeable agreements.
     */
    getAgreements(): Promise<Agreement[]> {
        let url_ = this.baseUrl + "/Legal/facade/Agreement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgreements(_response);
        });
    }

    protected processGetAgreements(response: Response): Promise<Agreement[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Agreement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Agreement[]>(null as any);
    }

    /**
     * Gets the GDPR legal document
     * @return A T:AgreementLegalDocument containing the GDPR file data matching user culture.
     */
    getGDPRAgreementDocument(code: string): Promise<AgreementLegalDocument> {
        let url_ = this.baseUrl + "/Legal/facade/Agreement/{code}/gdprdocument";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGDPRAgreementDocument(_response);
        });
    }

    protected processGetGDPRAgreementDocument(response: Response): Promise<AgreementLegalDocument> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementLegalDocument.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgreementLegalDocument>(null as any);
    }

    /**
     * Gets the user manual.
     * @return The User Manual.
     */
    getUserManual(): Promise<string> {
        let url_ = this.baseUrl + "/Legal/facade/Agreement/usermanual";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserManual(_response);
        });
    }

    protected processGetUserManual(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class AgreementPublicClient extends OAuthBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets GDPR Conditions.
     * @return The GDPR Conditions.
     */
    getGDPRConditions(): Promise<AgreementLegalDocument> {
        let url_ = this.baseUrl + "/Legal/facade/agreementpublic/gdpr";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGDPRConditions(_response);
        });
    }

    protected processGetGDPRConditions(response: Response): Promise<AgreementLegalDocument> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementLegalDocument.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgreementLegalDocument>(null as any);
    }

    /**
     * Gets Privacy Policy.
     * @return The  Privacy Policy.
     */
    getPrivacyPolicy(): Promise<AgreementLegalDocument> {
        let url_ = this.baseUrl + "/Legal/facade/agreementpublic/privacypolicy";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrivacyPolicy(_response);
        });
    }

    protected processGetPrivacyPolicy(response: Response): Promise<AgreementLegalDocument> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementLegalDocument.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgreementLegalDocument>(null as any);
    }
}

export class EnvironmentClient extends OAuthBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Return details information about the application.
     * @return Return the environment information.
     */
    get(): Promise<EnvironmentInfo | null> {
        let url_ = this.baseUrl + "/Legal/facade/Environment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<EnvironmentInfo | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(Message.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("Error during the process of the request.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EnvironmentInfo.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentInfo | null>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class AgreementAckResult implements IAgreementAckResult {
    acknowledged?: string[] | undefined;
    missing?: string[] | undefined;

    constructor(data?: IAgreementAckResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["acknowledged"])) {
                this.acknowledged = [] as any;
                for (let item of _data["acknowledged"])
                    this.acknowledged!.push(item);
            }
            if (Array.isArray(_data["missing"])) {
                this.missing = [] as any;
                for (let item of _data["missing"])
                    this.missing!.push(item);
            }
        }
    }

    static fromJS(data: any): AgreementAckResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementAckResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.acknowledged)) {
            data["acknowledged"] = [];
            for (let item of this.acknowledged)
                data["acknowledged"].push(item);
        }
        if (Array.isArray(this.missing)) {
            data["missing"] = [];
            for (let item of this.missing)
                data["missing"].push(item);
        }
        return data;
    }
}

export interface IAgreementAckResult {
    acknowledged?: string[] | undefined;
    missing?: string[] | undefined;
}

export class Agreement implements IAgreement {
    id?: string | undefined;
    code?: string | undefined;
    scope?: string | undefined;
    title?: string | undefined;
    subTitle?: string | undefined;
    body?: string | undefined;

    constructor(data?: IAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.scope = _data["scope"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): Agreement {
        data = typeof data === 'object' ? data : {};
        let result = new Agreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["scope"] = this.scope;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["body"] = this.body;
        return data;
    }
}

export interface IAgreement {
    id?: string | undefined;
    code?: string | undefined;
    scope?: string | undefined;
    title?: string | undefined;
    subTitle?: string | undefined;
    body?: string | undefined;
}

export class AgreementLegalDocument implements IAgreementLegalDocument {
    content?: string | undefined;

    constructor(data?: IAgreementLegalDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AgreementLegalDocument {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementLegalDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        return data;
    }
}

export interface IAgreementLegalDocument {
    content?: string | undefined;
}

/** Represents a fault message. */
export class Message implements IMessage {
    /** Gets or sets the code of the current Message when applicable.
Sometimes we should implement a code for an error following what the business ask. */
    code?: string | undefined;
    /** Gets or sets the subject of the currendt Message. */
    subject?: string | undefined;
    /** Gets or sets the text of the current Message. */
    text?: string | undefined;
    /** Gets or sets the MessageType of the current Message. */
    type?: MessageType;
    /** Gets or sets the MessageCategory of the current Message. */
    category?: MessageCategory;
    /** Used for compatibility with previous version of Egaf. Technical and Business is new way but the previous category was Described and Undescribed!
So a transformation is done Technical == Undescribed, Business == Described. */
    serialisationCategory?: string;
    /** Add the stacktrace to receive the information on the messsage but not persist it (back to
other app. This is only used when we want to log the message. */
    stackTrace?: string | undefined;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.subject = _data["subject"];
            this.text = _data["text"];
            this.type = _data["type"];
            this.category = _data["category"];
            this.serialisationCategory = _data["serialisationCategory"];
            this.stackTrace = _data["stackTrace"];
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["subject"] = this.subject;
        data["text"] = this.text;
        data["type"] = this.type;
        data["category"] = this.category;
        data["serialisationCategory"] = this.serialisationCategory;
        data["stackTrace"] = this.stackTrace;
        return data;
    }
}

/** Represents a fault message. */
export interface IMessage {
    /** Gets or sets the code of the current Message when applicable.
Sometimes we should implement a code for an error following what the business ask. */
    code?: string | undefined;
    /** Gets or sets the subject of the currendt Message. */
    subject?: string | undefined;
    /** Gets or sets the text of the current Message. */
    text?: string | undefined;
    /** Gets or sets the MessageType of the current Message. */
    type?: MessageType;
    /** Gets or sets the MessageCategory of the current Message. */
    category?: MessageCategory;
    /** Used for compatibility with previous version of Egaf. Technical and Business is new way but the previous category was Described and Undescribed!
So a transformation is done Technical == Undescribed, Business == Described. */
    serialisationCategory?: string;
    /** Add the stacktrace to receive the information on the messsage but not persist it (back to
other app. This is only used when we want to log the message. */
    stackTrace?: string | undefined;
}

/** Specifies the different types of a Message. */
export enum MessageType {
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
    Critical = "Critical",
}

/** Specifies the different categories of a Message. */
export enum MessageCategory {
    Technical = "Technical",
    Business = "Business",
}

export class EnvironmentInfo implements IEnvironmentInfo {
    name?: string | undefined;
    server?: string | undefined;
    databaseInfo?: DatabaseInfo[] | undefined;

    constructor(data?: IEnvironmentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.server = _data["server"];
            if (Array.isArray(_data["databaseInfo"])) {
                this.databaseInfo = [] as any;
                for (let item of _data["databaseInfo"])
                    this.databaseInfo!.push(DatabaseInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvironmentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["server"] = this.server;
        if (Array.isArray(this.databaseInfo)) {
            data["databaseInfo"] = [];
            for (let item of this.databaseInfo)
                data["databaseInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEnvironmentInfo {
    name?: string | undefined;
    server?: string | undefined;
    databaseInfo?: DatabaseInfo[] | undefined;
}

export class DatabaseInfo implements IDatabaseInfo {
    server?: string | undefined;
    database?: string | undefined;

    constructor(data?: IDatabaseInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.server = _data["server"];
            this.database = _data["database"];
        }
    }

    static fromJS(data: any): DatabaseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DatabaseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["server"] = this.server;
        data["database"] = this.database;
        return data;
    }
}

export interface IDatabaseInfo {
    server?: string | undefined;
    database?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

require('es6-promise').polyfill();
require('isomorphic-fetch');